import React from 'react';
import styled from 'styled-components';
import LoadingSpinner from '../../components/LoadingSpinner';
import {
    AuthCard,
    AuthColumn,
    AuthOnboardingCardSubtitle,
    FullLogo,
} from '../authentication/authFormCommon';

const InviteLoadingState: React.FC = () => (
    <AuthColumn>
        <FullLogo />
        <InviteLoadingCard>
            <SpinnerWrap>
                <LoadingSpinner height="58px" width="58px" />
            </SpinnerWrap>
            <AuthOnboardingCardSubtitle>Verifying your invite...</AuthOnboardingCardSubtitle>
        </InviteLoadingCard>
    </AuthColumn>
);

const InviteLoadingCard = styled(AuthCard)`
    align-items: center;
    gap: 16px;
`;

const SpinnerWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 58px;
    height: 61px;
`;

export default InviteLoadingState;
